import { render, staticRenderFns } from "./Anuncio30s.vue?vue&type=template&id=72169fdc&scoped=true"
import script from "./Anuncio30s.vue?vue&type=script&lang=js"
export * from "./Anuncio30s.vue?vue&type=script&lang=js"
import style0 from "./Anuncio30s.vue?vue&type=style&index=0&id=72169fdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72169fdc",
  null
  
)

export default component.exports